import { FC, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import { FullPageLoader } from '@components';
import useInitializeUser from '@hooks/useInitializeUser';

const ShareLayout: FC = () => {
  // Automatically fetch user details for authenticated users
  const { isAuthenticationComplete } = useInitializeUser();

  // Show loader while authentication initialization is in progress
  if (!isAuthenticationComplete) {
    return <FullPageLoader hasSideNav={false} />;
  }

  return (
    <Box
      component="main"
      id="share_layout_container"
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {/* Suspense catches lazy-loaded dashboard components */}
        <Suspense fallback={<FullPageLoader hasSideNav={false} />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};

export default ShareLayout;
